(function () {
  'use strict';

  var MOBILE_MEDIA_QUERY = '(max-width: 767px)';
  var COLLECTION_ICON_URL = 'https://cdn.shopify.com/s/files/1/0601/3206/5515/files/EZOKO_ICON_0.png?v=1788879801';
  var popularQueries = [];
  var currentQuery = '';
  var productAttributions = new Map();

  function readConfig() {
    var element = document.getElementById('ezoko-search-config');

    if (!element) {
      return null;
    }

    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      console.error('EZOKO search configuration could not be read.', error);
      return null;
    }
  }

  function isMobileSearch() {
    return window.matchMedia(MOBILE_MEDIA_QUERY).matches;
  }

  function replaceToken(value, token, replacement) {
    return String(value || '').replace(token, String(replacement));
  }

  function formatCount(pattern, count, formatter) {
    var formattedCount = formatter ? formatter(count || 0) : String(count || 0);
    return replaceToken(pattern, '__COUNT__', formattedCount);
  }

  function formatNumber(value) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en').format(Number(value || 0));
  }

  function searchUrl(query) {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return root + 'search?q=' + encodeURIComponent(query || '');
  }

  function sourceHasElement(element) {
    return element !== undefined && element !== null && element !== false;
  }

  function setInputQuery(query) {
    var input = document.querySelector('.aa-DetachedFormContainer .aa-Input') || document.querySelector('#ezoko-algolia-search .aa-Input');

    if (!input) {
      return;
    }

    var valueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
    valueSetter.set.call(input, query);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.focus();
  }

  function restoreMobileSearchFocus() {
    window.setTimeout(function () {
      var trigger = document.querySelector('#ezoko-algolia-search .aa-DetachedSearchButton');
      if (trigger && !document.querySelector('.aa-DetachedOverlay')) {
        trigger.focus();
      }
    }, 0);
  }

  function ensureUniqueSearchIds() {
    var trigger = document.querySelector('#ezoko-algolia-search .aa-DetachedSearchButton');

    if (trigger && /-label$/.test(trigger.id)) {
      trigger.id = trigger.id.replace(/-label$/, '-detached-trigger');
    }
  }

  function featuredCollectionsTemplate(html, config) {
    var collections = (config.featuredCollections || []).filter(function (collection) {
      return collection && collection.title && collection.url;
    });

    if (!collections.length) {
      return null;
    }

    return html`
      <section class="ezoko-search-section ezoko-featured-collections">
        <h3 class="ezoko-section-header">${config.translations.featuredCollections}</h3>
        <div class="ezoko-collection-tiles">
          ${collections.map(function (collection) {
            var desktopImage = collection.desktopImage || collection.image || collection.mobileImage;
            var mobileImage = collection.mobileImage || collection.image || collection.desktopImage;

            return html`
              <a class="ezoko-collection-tile" href="${collection.url}">
                ${desktopImage || mobileImage
                  ? html`
                      <picture>
                        ${mobileImage ? html`<source media="${MOBILE_MEDIA_QUERY}" srcset="${mobileImage}" width="480" height="240" />` : null}
                        <img
                          src="${desktopImage || mobileImage}"
                          alt=""
                          loading="lazy"
                          decoding="async"
                          width="720"
                          height="300"
                        />
                      </picture>
                    `
                  : html`<span class="ezoko-collection-tile-placeholder" aria-hidden="true"></span>`}
                <span class="ezoko-collection-tile-scrim" aria-hidden="true"></span>
                <span class="ezoko-collection-tile-label">${collection.title}</span>
              </a>
            `;
          })}
        </div>
      </section>
    `;
  }

  function popularQueriesTemplate(html, config) {
    if (!popularQueries.length) {
      return null;
    }

    return html`
      <section class="ezoko-search-section ezoko-popular-searches">
        <h3 class="ezoko-section-header">${config.translations.popular}</h3>
        <div class="ezoko-popular-chips">
          ${popularQueries.slice(0, 6).map(function (query) {
            return html`
              <button type="button" class="ezoko-popular-chip" data-ezoko-search-query="${query}">
                ${query}
              </button>
            `;
          })}
        </div>
      </section>
    `;
  }

  function viewAllTemplate(html, config, query, count, formatNumber) {
    if (!query || !count) {
      return null;
    }

    return html`
      <a class="ezoko-view-all-results" href="${searchUrl(query)}">
        <span>${formatCount(config.translations.viewAll, count, formatNumber)}</span>
        <svg viewBox="0 0 14 14" fill="none" aria-hidden="true">
          <path d="M2 7h10M8 3l4 4-4 4"></path>
        </svg>
      </a>
    `;
  }

  function noResultsTemplate(html, state, config) {
    var query = (state.query || '').trim();
    var title = replaceToken(config.translations.noMatches, '__QUERY__', query);

    return html`
      <div class="ezoko-search-layout ezoko-search-layout--no-results">
        <div class="ezoko-no-results" role="status">
          <div class="ezoko-no-results-title">${title}</div>
          <div class="ezoko-no-results-hint">${config.translations.noResultsHint}</div>
        </div>
        ${popularQueriesTemplate(html, config)}
        ${featuredCollectionsTemplate(html, config)}
      </div>
    `;
  }

  function registerHook(algolia, hookName, callback) {
    if (algolia.hooks.allowedHooks.indexOf(hookName) === -1) {
      console.warn('EZOKO search skipped unsupported Algolia hook:', hookName);
      return;
    }

    algolia.hooks.registerHook(hookName, callback);
  }

  document.addEventListener('click', function (event) {
    var queryControl = event.target.closest('[data-ezoko-search-query]');
    var productLink = event.target.closest('.ezoko-product-result');

    if (event.target.closest('.aa-DetachedCancelButton')) {
      restoreMobileSearchFocus();
    }

    if (productLink) {
      var attribution = productAttributions.get(productLink.getAttribute('href'));
      if (attribution) {
        attribution.track(attribution.item);
      }
    }

    if (!queryControl) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    setInputQuery(queryControl.getAttribute('data-ezoko-search-query') || '');
  });

  document.addEventListener('keydown', function (event) {
    var input = event.target.closest && event.target.closest('.aa-Input');

    if (input && event.key === 'Escape' && isMobileSearch()) {
      restoreMobileSearchFocus();
    }

    if (!input || event.key !== 'Enter' || event.defaultPrevented) {
      return;
    }

    var panel = document.querySelector('.ezoko-search-panel');
    var selectedItem = panel && panel.querySelector('.aa-Item[aria-selected="true"]');

    if (selectedItem || !input.value.trim()) {
      return;
    }

    var submitButton = input.closest('.aa-Form') && input.closest('.aa-Form').querySelector('.aa-SubmitButton');

    if (submitButton) {
      event.preventDefault();
      submitButton.click();
    }
  });

  document.addEventListener('scroll', function (event) {
    if (!isMobileSearch() || !event.target.closest || !event.target.closest('.ezoko-search-panel')) {
      return;
    }

    var input = document.querySelector('.aa-DetachedFormContainer .aa-Input');
    if (input && document.activeElement === input) {
      input.blur();
    }
  }, true);

  document.addEventListener('algolia.autocomplete.afterInit', ensureUniqueSearchIds);

  document.addEventListener('algolia.hooks.initialize', function () {
    var algolia = window.algoliaShopify;
    var config = readConfig();

    if (!algolia || !config || !algolia.hooks) {
      return;
    }

    registerHook(algolia, 'beforeAutocompletePluginOptions', function (options, context) {
      if (context.pluginName === 'products') {
        options.searchParameters.hitsPerPage = 6;
      } else if (context.pluginName === 'collections') {
        options.searchParameters.hitsPerPage = isMobileSearch() ? 2 : 3;
      } else if (context.pluginName === 'suggestions') {
        options.searchParameters.hitsPerPage = isMobileSearch() ? 3 : 5;
      }

      return options;
    });

    registerHook(algolia, 'beforeAutocompletePluginsArray', function () {
      var plugins = Array.prototype.slice.call(arguments);
      var recentSearchesLibrary = window['@algolia/autocomplete-plugin-recent-searches'];

      if (!recentSearchesLibrary || !recentSearchesLibrary.createLocalStorageRecentSearchesPlugin) {
        console.warn('EZOKO search could not load the Algolia recent-searches plugin.');
        return plugins;
      }

      var recentSearchesPlugin = recentSearchesLibrary.createLocalStorageRecentSearchesPlugin({
        key: 'ezoko-search',
        limit: 2,
        translations: {
          removeSearchTitle: config.translations.removeRecent
        },
        transformSource: function (params) {
          var source = params.source;

          return Object.assign({}, source, {
            getItemUrl: function (sourceParams) {
              return searchUrl(sourceParams.item.query);
            },
            templates: Object.assign({}, source.templates, {
              item: function (templateParams) {
                var item = templateParams.item;
                var html = templateParams.html;

                return html`
                  <a class="aa-ItemLink ezoko-recent-search" href="${searchUrl(item.query)}">
                    ${source.templates.item(templateParams).props.children}
                  </a>
                `;
              }
            })
          });
        }
      });

      plugins.unshift(recentSearchesPlugin);
      return plugins;
    });

    registerHook(algolia, 'beforeAutocompleteOptions', function (options) {
      var originalOnStateChange = options.onStateChange;
      var originalOnSubmit = options.onSubmit;

      options.placeholder = config.placeholder;
      options.openOnFocus = true;
      options.detachedMediaQuery = MOBILE_MEDIA_QUERY;
      options.panelPlacement = 'end';
      options.stallThreshold = 300;
      options.classNames = Object.assign({}, options.classNames, {
        panel: 'ezoko-search-panel'
      });
      options.translations = Object.assign({}, options.translations, {
        clearButtonTitle: config.translations.clear,
        detachedCancelButtonText: config.translations.cancel,
        submitButtonTitle: config.translations.submit
      });

      options.onStateChange = function (params) {
        if (originalOnStateChange) {
          originalOnStateChange(params);
        }

        var state = params.state;
        var query = (state.query || '').trim();
        var desktopPanelOpen = state.isOpen && !isMobileSearch();

        if (query !== currentQuery) {
          productAttributions.clear();
        }

        currentQuery = query;
        ensureUniqueSearchIds();

        document.body.classList.toggle('ezoko-search-panel-open', desktopPanelOpen);
        document.body.classList.toggle('ezoko-search-has-query', Boolean(query));
        document.body.classList.toggle('ezoko-search-is-loading', state.status === 'stalled');

        document.querySelectorAll('.aa-DetachedFormContainer .aa-SubmitButton').forEach(function (button) {
          button.disabled = !query;
          button.setAttribute('aria-label', config.translations.submit);
        });

        document.querySelectorAll('.aa-LoadingIndicator').forEach(function (indicator) {
          indicator.setAttribute('aria-label', config.translations.loading);
          indicator.setAttribute('role', 'status');
        });
      };

      options.onSubmit = function (params) {
        if (!(params.state.query || '').trim()) {
          return;
        }

        if (originalOnSubmit) {
          originalOnSubmit(params);
        }
      };

      return options;
    });

    registerHook(algolia, 'beforeAutocompleteHeaderTemplate', function (_defaultTemplate, templateOptions, resource) {
      var html = templateOptions.html;
      var state = templateOptions.state;
      var isProducts = resource === algolia.translations.products || String(resource).toLowerCase() === 'products';
      var isCollections = resource === algolia.translations.collections || String(resource).toLowerCase() === 'collections';
      var title = isCollections ? config.translations.collections : resource;

      if (isProducts) {
        var count = state.context.nbProducts || 0;
        return html`
          <div class="ezoko-section-header-row">
            <h3 class="ezoko-section-header">${config.translations.products}</h3>
            <span class="ezoko-match-count">
              ${formatCount(config.translations.matches, count, formatNumber)}
            </span>
          </div>
        `;
      }

      return html`<h3 class="ezoko-section-header">${title}</h3>`;
    });

    registerHook(algolia, 'beforeAutocompleteProductTemplate', function (
      _defaultTemplate,
      templateOptions,
      distinct,
      itemLink,
      trackSearchAttribution
    ) {
      var html = templateOptions.html;
      var item = templateOptions.item;
      var components = templateOptions.components;
      var image = algolia.helpers.renderImage(item, 166);
      var basePrice = item._productLevel ? item.variants_min_price : item.price;
      var compareAtPrice = item._productLevel ? item.variants_compare_at_price_min : item.compare_at_price;
      var comparePrice = algolia.helpers.displayStrikedPrice(basePrice, compareAtPrice, item.currency);
      var hasSalePrice = Boolean(comparePrice);
      var optionCount = Number(item.variants_count || 0);
      productAttributions.set(itemLink, {
        item: item,
        track: trackSearchAttribution
      });

      return html`
        <a href="${itemLink}" class="aa-ItemLink ezoko-product-result">
          <img
            class="ezoko-product-image"
            src="${image.src}"
            srcset="${image.srcset}"
            sizes="83px"
            alt=""
            loading="lazy"
            width="83"
            height="83"
          />
          <span class="ezoko-product-text">
            ${item.vendor ? html`<span class="ezoko-product-vendor">${item.vendor}</span>` : null}
            <span class="ezoko-product-title">${components.Highlight({ hit: item, attribute: 'title' })}</span>
            <span class="ezoko-product-price ${hasSalePrice ? 'is-sale' : ''}">
              ${algolia.helpers.displayPrice(item, distinct, item._productLevel)}
              ${comparePrice ? html`<span class="ezoko-product-compare-price">${comparePrice}</span>` : null}
              ${optionCount > 1
                ? html`<span class="ezoko-product-meta">${formatCount(config.translations.optionCount, optionCount, formatNumber)}</span>`
                : null}
            </span>
          </span>
        </a>
      `;
    });

    registerHook(algolia, 'beforeAutocompleteCollectionsTemplate', function (_defaultTemplate, templateOptions, itemLink) {
      var html = templateOptions.html;
      var item = templateOptions.item;
      var components = templateOptions.components;
      var count = Number(item.products_count || 0);
      var countPattern = isMobileSearch()
        ? config.translations.collectionProductCount
        : config.translations.productCount;

      return html`
        <a href="${itemLink}" class="aa-ItemLink ezoko-collection-result">
          <img
            class="ezoko-collection-image"
            src="${COLLECTION_ICON_URL}"
            alt=""
            loading="eager"
            decoding="async"
            width="60"
            height="60"
          />
          <span class="ezoko-collection-text">
            <span class="ezoko-collection-title">${components.Highlight({ hit: item, attribute: 'title' })}</span>
            <span class="ezoko-collection-count">${formatCount(countPattern, count, formatNumber)}</span>
          </span>
          <svg class="ezoko-collection-chevron" viewBox="0 0 12 12" fill="none" aria-hidden="true">
            <path d="M4 2l4 4-4 4"></path>
          </svg>
        </a>
      `;
    });

    registerHook(algolia, 'beforeAutocompleteSuggestionsTemplate', function (_defaultTemplate, templateOptions) {
      var html = templateOptions.html;
      var item = templateOptions.item;
      var components = templateOptions.components;

      if (!currentQuery && popularQueries.indexOf(item.query) === -1) {
        popularQueries.push(item.query);
      }

      return html`
        <div class="ezoko-query-suggestion">
          <a class="aa-ItemLink ezoko-query-suggestion-link" href="${searchUrl(item.query)}">
            <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
              <circle cx="8.8" cy="8.8" r="5.3"></circle>
              <path d="M12.8 12.8L17 17"></path>
            </svg>
            <span>${components.ReverseHighlight({ hit: item, attribute: 'query' })}</span>
          </a>
          <span class="ezoko-enter-hint" aria-hidden="true">↵</span>
          <button
            type="button"
            class="ezoko-tap-ahead"
            data-ezoko-search-query="${item.query}"
            aria-label="${replaceToken(config.translations.insertSuggestion, '__QUERY__', item.query)}"
          >
            <svg viewBox="0 0 14 14" fill="none" aria-hidden="true">
              <path d="M4 10L10 4M5 4h5v5"></path>
            </svg>
          </button>
        </div>
      `;
    });

    registerHook(algolia, 'beforeAutocompleteMainTemplate', function (
      _defaultTemplate,
      templateOptions,
      elements,
      displaySuggestions
    ) {
      var html = templateOptions.html;
      var state = templateOptions.state;
      var query = (state.query || '').trim();
      var count = state.context.nbProducts || 0;
      var suggestions = displaySuggestions && sourceHasElement(elements.querySuggestionsPlugin)
        ? elements.querySuggestionsPlugin
        : null;

      if (!query) {
        var hasRecentSearches = sourceHasElement(elements.recentSearchesPlugin);
        var hasPreQueryDiscovery = hasRecentSearches || Boolean(suggestions);

        return html`
          <div class="ezoko-search-layout ezoko-search-layout--pre-query">
            <div class="ezoko-search-content ${hasPreQueryDiscovery ? '' : 'ezoko-search-content--featured-only'}">
              <div class="ezoko-discovery-column">
                ${hasRecentSearches
                  ? html`
                    <section class="ezoko-search-section ezoko-recent-searches">
                      <h3 class="ezoko-section-header">${config.translations.recent}</h3>
                      ${elements.recentSearchesPlugin}
                    </section>
                  `
                  : null}
                ${suggestions
                  ? html`
                    <section class="ezoko-search-section ezoko-popular-source">
                      <h3 class="ezoko-section-header">${config.translations.popular}</h3>
                      ${suggestions}
                    </section>
                  `
                  : null}
              </div>
              <div class="ezoko-featured-column">${featuredCollectionsTemplate(html, config)}</div>
            </div>
          </div>
        `;
      }

      return html`
        <div class="ezoko-search-layout ezoko-search-layout--results">
          <div class="ezoko-search-content">
            <div class="ezoko-discovery-column">
              ${suggestions
                ? html`
                  <section class="ezoko-search-section ezoko-query-suggestions">
                    <h3 class="ezoko-section-header">${config.translations.suggestions}</h3>
                    ${suggestions}
                  </section>
                `
                : null}
              ${elements.collections}
              ${elements.articles}
              ${elements.pages}
              ${elements.redirectUrlPlugin}
            </div>
            <div class="ezoko-products-column">${elements.products}</div>
          </div>
          ${viewAllTemplate(html, config, query, count, formatNumber)}
        </div>
      `;
    });

    registerHook(algolia, 'beforeAutocompleteNoResultsTemplate', function (_defaultTemplate, templateOptions) {
      return noResultsTemplate(templateOptions.html, templateOptions.state, config);
    });
  });
})();
